import moment from 'moment'
import { ValueFormatterParams } from '@ag-grid-enterprise/all-modules'
import { Formatter } from '@/filters/formatter'

export class VtGridValueFormatter {
    static dateFormatter(params: ValueFormatterParams): string {
        return Formatter.date(params.value)
    }
    static dateTimeFormatter(params: ValueFormatterParams): string {
        return params.value
            ? moment(params.value).format('llll')
            : ''
    }

    static numberFormatter(params: ValueFormatterParams): string {
        return Formatter.number(params.value)
    }
    static decimalFormatter(params: ValueFormatterParams): string {
        return Formatter.number(params.value, true)
    }
}
